import { render, staticRenderFns } from "./VerticalDotsButton.vue?vue&type=template&id=84929658&scoped=true"
import script from "./VerticalDotsButton.vue?vue&type=script&lang=js"
export * from "./VerticalDotsButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84929658",
  null
  
)

export default component.exports